export default {
  title: 'Company Reservation Service Deactivated',
  description: 'The reservation service is currently inactive for this company. You can activate it under Services.',
  button: {
    settings: 'Go to Settings',
  },
};
